<template>
  <q-input
    v-model="selectedDate"
    :label="config.label"
    class="month-picker-input"
    type="text"
    @click="popupVisible = true"
    bottom-slots
    :clearable="config.clearable"
  >
    <template v-slot:append>
      <q-icon
        name="event"
        class="cursor-pointer"
        color="grey-7"
      >
        <q-popup-proxy
          ref="qDateProxy"
          v-model="popupVisible"
          :breakpoint="9999999"
          transition-show="scale"
          transition-hide="scale"
        >
          <month-picker
            :default-year="new Date().getFullYear()"
            lang="en"
            :default-month="getMonth()"
            clearable
            @input="populateInput"
          />
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-input>
</template>

<script>
import MonthPicker from './MonthPicker.vue'
import monthPicker from './month-picker'
import moment from 'moment'
export default {
  name: 'MonthPickerWithInput',
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.event = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.event)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.event)
      }
    }
  },
  components: {
    MonthPicker
  },
  mixins: [monthPicker],
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    modelProps: {
      type: String,
      default: ''
    },
    rootModel: {
      type: Object,
      default: () => {}
    },
    parent: {
      type: Object,
      default: () => {}
    },
    originModel: {
      type: String,
      default: () => {}
    }
  },
  data() {
    return {
      monthPickerVisible: false,
      selectedDate: this.modelProps ? this.modelProps : null,
      popupVisible: false
    }
  },
  watch: {
    selectedDate(newValue) {
      if(this.R.isNil(newValue)) {
        this.$emit("input", this.selectedDate)
      }
    }
  },
  methods: {
    populateInput(date) {
      this.selectedDate = moment(date.from).format('MM/YYYY')
      this.monthPickerVisible = false
      this.$emit("input", this.selectedDate)
      this.popupVisible = false
    },
    getMonth() {
      if(!this.selectedDate) {
        return null
      }
      return moment(this.selectedDate, 'MM/YYYY').month() + 1
    }
  }
} 
</script>
